import { WorkloadStatus } from '@buf/studyo_studyo-today-schools.bufbuild_es/studyo/today/schools/v1/resources/workload_status_pb';
import { FeatureFlagService } from '../../services';

export type WorkloadData<T> = T | 'fetching' | 'error';

export function getShouldShowWorkloadStatusInCalendar(
  status: WorkloadData<WorkloadStatus> | undefined,
  featureFlag: FeatureFlagService
): boolean {
  return (
    featureFlag.isEnabled('workload-manager') &&
    status != null &&
    status != 'fetching' &&
    status != 'error' &&
    [WorkloadStatus.ABOVE_THRESHOLD, WorkloadStatus.AT_THRESHOLD].includes(status)
  );
}
